export default {
      id: "besom-usage",
      viewBox: "0 0 50 64",
      url: __webpack_public_path__ + "../../sprite.svg#besom-usage",
      toString: function () {
        return this.url;
      }
    }